<template>
	<div class="mt50">

    <div v-if="error" class="frm-error mb20">{{ error_message }}</div>

    <div v-if="loading">
      <div class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>
    </div>      
    <table v-else class="c-tbl-sus">
      <thead>
        <tr>
          <th class="text-center" width="100">CDU</th>
          <th class="text-center">
            <table class="c-tbl-sus w100">
              <tr>
                <th width="50%" class="text-center pb0">{{ $t('Artículo descatalogado') }}</th>
                <th width="50%" class="text-center pb0">{{ $t('Artículo propuesto') }}</th>
              </tr>
            </table>
          </th>
          <th class="text-center" width="140">{{ $t('Edición posterior') }}</th>
          <th class="text-center" width="80">{{ $t('Aceptar') }}</th>
          <th class="text-center" width="85">{{ $t('Rechazar') }}</th>  
        </tr>
      </thead>
      <tbody>
        <template v-for=" (item, index) in articulos ">
          <sustituciones-table-row
            :item="item"
            state="ACEPTADO"
            :key="index"
          >
          </sustituciones-table-row>
          <tr>
            <td colspan="5" class="borders-none"></td>
          </tr>
        </template>
      </tbody>
    </table>

    <div v-if=" sinArticulos" class="text-center mt20"><h5>{{ $t('No hay artículos') }}</h5></div>

  </div>
</template>

<script>
  import axios from 'axios'; 
  import { mapGetters, mapMutations } from 'vuex';
  
  import SustitucionesTableRow from '@/components/usuario/SustitucionesTableRow'

	export default {
    components: { SustitucionesTableRow },
    data: () => {
      return {
        error_message: '',
        error: false,
        loading: false,
        articulos: [],
        sinArticulos: false,
       }
    },
    mounted(){
      this.loadArticulos()
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getIdConsorcio', 'getReferencia', 'getUserRole', 'getActiveBiblioteca']),
    },
    methods: {
      ...mapMutations(['setSustitucionesCantidades']),
      loadArticulos() {
        let queryToSend = {};
        if( this.getIdConsorcio == 0 ){ 
          queryToSend['id_consorcio'] = this.getIdConsorcio;
        }else{ 
          queryToSend['id_consorcio'] = this.getIdConsorcio;
          queryToSend['referencia'] = this.getReferencia;
        }

        // INICIO CONSORCIOS
        if(this.getUserRole == 'badmin'){
          queryToSend['bibl'] = this.getActiveBiblioteca;
        }
        // FIN CONSORCIOS

        this.showLoading();

        axios.get( this.getApiUrl + this.getLocale + '/misconsultas/sustituciones/listado', { 
          params: queryToSend
        })
          .then( (respuesta) =>{ 
            //this.articulos = respuesta.data.data.articulos;           
            
            respuesta.data.data.articulos.forEach(element => {
              if( element.ESTADO === 'ACEPTADO' ){
                this.articulos.push(element)
              }
            });

            this.sinArticulos = this.articulos.length > 0 ? 0 : 1

            this.$store.commit('setSustitucionesCantidades',{
              pendientes: respuesta.data.data.pendientes,
              sinPropuestas: respuesta.data.data.sin_propuestas,
              rechazados: respuesta.data.data.rechazados,
              aceptados: respuesta.data.data.aceptados
            })

            this.hideLoading();
          })
        .catch( (error) =>{ 
          this.articulos = [];
          this.hideLoading();
          this.error_message = error.response.data.msg;
          this.error = true;
        });
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
  }
	
</script>

<i18n>
  {
    "es": {
      "Artículo descatalogado": "Artículo descatalogado",
      "Artículo propuesto": "Artículo propuesto",
      "Aceptar": "Aceptar",
      "Rechazar": "Rechazar",
      "Edición posterior": "Edición posterior",
      "Guardar decisiones": "Guardar decisiones",
      "No hay artículos": "No hay artículos"
    },
    "ca": {
      "Artículo descatalogado": "Article descatalogat",
      "Artículo propuesto": "Article proposat",
      "Aceptar": "Acceptar",
      "Rechazar": "Rebutjar",
      "Edición posterior": "Edició posterior",
      "Guardar decisiones": "Guardar decisions",
      "No hay artículos": "No hi ha articles"
    }
  }
</i18n>